import { flow } from 'lodash';
import SliderGroup from './SliderGroup';
import withUserInput from '../../hocs/UserInput';
import withValidation from '../../hocs/Validation';

export default flow(withUserInput, withValidation)(SliderGroup);



// WEBPACK FOOTER //
// ../core/src/components/Slider/index.js